import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { withEndtest } from '@brainstud/react-tbl/themes/pgw/v1/containers'
import { Page, Animation } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import PageFooter from '@brainstud/react-tbl/themes/pgw/v1/components/views/page/PageFooter'
import IntroTemplate from 'content/endtest/Intro'
import { Quiz } from '@brainstud/react-widget-quiz'

class EndtestIntroView extends React.Component {
  componentDidMount() {
    scrollTop()
    this.props.app.setLocation({ label: 'endtest' })
    this.props.app.triggerTheme(this.props.navigation.theme || 'default')
  }

  render() {
    return (
      <Page container>
        <Quiz.IntroView
          match={this.props.match}
          location={this.props.location}
        >
          <IntroTemplate />
        </Quiz.IntroView>

        <Quiz.FooterView>
          {footer => (
            <Animation name="slideInDown" delay={300}>
              <PageFooter {...footer} />
            </Animation>
          )}
        </Quiz.FooterView>
      </Page>
    )
  }
}

export default withEndtest(EndtestIntroView)
